// This file is duplicate in ruby assets. If you change something here change also in the other file.

import $ from 'jquery'
import './anitabs'

$(document).ready(function() {

    // RESPONSIVE
    var resizing = false;
    moveNavigation();
    $(window).on('resize', function() {
        if (!resizing) {
            (!window.requestAnimationFrame) ? setTimeout(moveNavigation, 300): window.requestAnimationFrame(moveNavigation);
            resizing = true;
        }
    });

    var scrolling = false;
    checkScrollbarPosition();
    $(window).on('scroll', function() {
        if (!scrolling) {
            (!window.requestAnimationFrame) ? setTimeout(checkScrollbarPosition, 300): window.requestAnimationFrame(checkScrollbarPosition);
            scrolling = true;
        }
    });

    function checkMQ() { return window.getComputedStyle(document.querySelector('.navigation-bar'), '::before').getPropertyValue('content').replace(/'/g, "").replace(/"/g, ""); }

    function moveNavigation() {
        var mq = checkMQ();
        if (mq == 'mobile' || mq == 'tablet') {

            // SWITCH LANGUAGE - IN MOBILE/TABLET - MOVE DIV
            $("nav.navigation-bar .language-switcher").appendTo("nav.navigation-bar .navigation-bar-menu-responsive .nbmrc-switch-lang");


            // DISCONNECT - IN MOBILE/TABLET - MOVE DIV
            $("nav.navigation-bar .navigation-bar-menu-responsive .nbmr-connected .power-off a").appendTo("nav.navigation-bar .navigation-bar-menu-responsive .nbmrc-switch-mode");


            // HAMBURGER MENU - IN MOBILE/TABLET - ADDCASS OPEN MENU
            $('.nbr-hamburger').on('click', function(event) {
                event.preventDefault();
                $("body").addClass( "nav-is-visible" );
            });


            // OVERLAY MENU - IN MOBILE/TABLET - REMOVECLASS CLOSE MENU
            $('.cd-nav-overlay').on('click', function(event) {
                event.preventDefault();
                $("body").removeClass( "nav-is-visible" );
            });


        } else if ((mq == 'desktop')) {

            // MENU/DROPDOWN - DESKTOP - OPEN MENU
            $("nav.navigation-bar").on("click", ".navigation-bar-dropdown", function() {
                if(!$(document).find('nav.navigation-bar .navigation-bar-dropdown-open').hasClass('close')){
                    $("nav.navigation-bar .navigation-bar-dropdown-open").removeClass("open");
                    $("nav.navigation-bar .navigation-bar-dropdown-open").addClass("close");
                } else {
                    setTimeout(function(){
                        $('nav.navigation-bar .navigation-bar-dropdown-open').removeClass('close').addClass('open');
                    }, 100);
                }
            });

            // MENU/DROPDOWN - DESKTOP - CLICK OUTSIDE
            $(document).on('click',function(e){
                var target = $(e.target)
                if(!target.closest('nav.navigation-bar .navigation-bar-dropdown').length && !target.closest('.open').length){
                    if(!$(document).find('nav.navigation-bar .navigation-bar-dropdown-open').hasClass('close')){
                        $("nav.navigation-bar .navigation-bar-dropdown-open").removeClass("open");
                        $("nav.navigation-bar .navigation-bar-dropdown-open").addClass("close");
                    }
                }
            });


            // SWITCH LANGUAGE - IN DESKTOP - MOVE DIV
            $("nav.navigation-bar .navigation-bar-menu-responsive .nbmrc-switch-lang").appendTo("nav.navigation-bar .navigation-bar-left");

        }


        // NOTIFICATION SYSTEM
        if (mq == 'mobile') {

            // NOTIFICATION SYSTEM - MOBILE - MOVE
            $("nav.navigation-bar #notification-system").appendTo("body");


            // NOTIFICATION SYSTEM - MOBILE - CLOSING X
            $('#notification-system .ns-close').on('click', function(event) {
                event.preventDefault();
                $("#notification-system").removeClass("open");
                $("#notification-system").addClass("close");
                $("body").removeClass( "ns-is-visible" );
            });


        } else if ((mq == 'desktop' || mq == 'tablet')) {

            // NOTIFICATION SYSTEM - DESKTOP/TABLET - MOVE NORMAL STATE
            $("body #notification-system").appendTo("nav.navigation-bar .nc-system-wrapper");

            // NOTIFICATION SYSTEM - DESKTOP/TABLET - HOVER DISPLAY
            $("#notification-system .ncni-more-options").mouseover(function() {
                $(this).parents(".nc-notif-item").toggleClass("hover");
            });

            $("#notification-system .ncni-more-options").mouseout(function() {
                $(this).parents(".nc-notif-item").toggleClass("hover");
            });

        }

        checkSelected(mq);
        resizing = false;
    }

    // dropdown.js - Custom code to not load bootstrap.js
    const dropdownButtons = document.querySelectorAll('[data-bs-toggle="dropdown"]');

    function bootstrapDropdown(button) {
        const dropdown = button.nextElementSibling as HTMLElement;
        dropdown.style.display = (dropdown.style.display === "none" || dropdown.style.display === "") ? "block" : "none";

        dropdown.style.position = "";
        dropdown.style.inset = "";
        dropdown.style.margin = "";
        dropdown.style.transform = "";
    }

    // Dropdown - Module - 'data-bs-toggle="dropdown"' attribute
    dropdownButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            bootstrapDropdown(this);
        });
    });

    // Dropdown - Module - Close the dropdowns if the user clicks outside of them
    window.onclick = function (event) {
        const dropdowns = document.querySelectorAll('.dropdown .dropdown-menu');
        dropdowns.forEach(function (dropdown) {
            const dropdownElement = dropdown as HTMLElement;
            if (dropdownElement.style.display === "block" && !event.target.closest('.dropdown')) {
                dropdownElement.style.display = "none";
            }
        });
    };

    function checkSelected(mq) { if (mq == 'desktop') $('.has-children.selected').removeClass('selected'); }

    function checkScrollbarPosition() {
        var mq = checkMQ();
        if (mq != 'mobile') {

            (($(window).scrollTop() + $(window).height() > $('.navigation-bar-menu-responsive').outerHeight()) && ($(".navigation-bar").outerHeight() - $('.navigation-bar-menu-responsive').outerHeight() != 0)) ? $('.navigation-bar-menu-responsive').addClass('is-fixed').css('bottom', 0): $('.navigation-bar-menu-responsive').removeClass('is-fixed').attr('style', '');
        }
        scrolling = false;
    }


    // USER MENU DASHBOARD NAVIGATION
    $("ul#dashboard_navigation_listing li.has-children").on("click", function() {
        $("ul#dashboard_navigation_listing li.has-children ul.children").slideUp(400);
        if (!($(this).find("ul.children").is(":visible"))) {
            $("ul#dashboard_navigation_listing li").removeClass("active");
            $(this).find("ul.children").slideDown(400);
            $(this).addClass("active");
        };
    });

    $("ul#dashboard_navigation_listing li.has-children ul.children li a").on("click", function() {
        $("ul#dashboard_navigation_listing li.has-children ul.children").delay(60000);
    });

    let lastPage = {};
    function get_notifications(scope, cursor, tabId) {
      if (lastPage[scope]) return;

      let last_date = $(tabId).find("div.nc-timeline").last().text().trim();

      $.ajax('/notifications', {
        data: {
          cursor: cursor,
          scope: scope,
          last_date: last_date
        },
        contentType: 'application/json',
        dataType: 'json'
      }).done(function(response) {
        if (cursor == null) {
          $(tabId + '.js-tabs-content').prepend(response['notifications_list']);
        } else {
          $(response['notifications_list']).insertAfter($(tabId + ' .nc-notif-item:last'));
        }

        if(!response['cursor']) {
          $(tabId + " .nc-load-more-notifs").hide();
          $(tabId + " .nc-no-more-notifs").show();
          lastPage[scope] = true;
        }

        if (scope == 'customer') {
          customerNotificationsCursor = response['cursor'];
        } else if (scope == 'service_provider') {
          providerNotificationsCursor = response['cursor'];
        }

        updateCounters(response)
      });
    }

    // NOTIFICATION SYSTEM - UPDATE COUNTERS
    function updateCounters(data) {
      updateCounter('#js-notif-counter', data.unread_notif_count);
      updateCounter('#js-notif-provider-counter', data.unread_notif_as_provider_count);
      updateCounter('#js-notif-customer-counter', data.unread_notif_as_customer_count);
    }

    function updateCounter(id, number) {
      let counter = $(id)
      counter.text(number);
    }

    // NOTIFICATION SYSTEM - FUNCTION - LOAD MORE TAB CLIENT
    function tab_client_load_more_notifs() {
      // Load more notifications ON SCROLLING - #tab-customer
      $('#notification-system .js-tabs-wrap #tab-customer').on('scroll', function() {
        let div = $(this).get(0);
        if(div.scrollTop + div.clientHeight >= div.scrollHeight) {
          get_customer_notifications();
        }
      });
    }

    // NOTIFICATION SYSTEM - FUNCTION - LOAD MORE TAB SP
    function tab_sp_load_more_notifs() {
      // Load more notifications ON SCROLLING - #tab-sp
      $('#notification-system .js-tabs-wrap #tab-sp').on('scroll', function() {
        let div = $(this).get(0);
        if(div.scrollTop + div.clientHeight >= div.scrollHeight) {
          get_sp_notifications();
        }
      });
    }

    var providerNotificationsCursor = null;
    function get_sp_notifications() {
      var tabId = '#tab-sp'
      get_notifications('service_provider', providerNotificationsCursor, tabId);
    }

    var customerNotificationsCursor = null;
    function get_customer_notifications() {
      var tabId = '#tab-customer'
      get_notifications('customer', customerNotificationsCursor, tabId);
    }

    // NOTIFICATION SYSTEM - TABS SWITCH
    $("#notification-system .ns-tabs .js-tabs-link").aniTabs({animation:"fade", animationSpeed:250, dragSpeed:0, slideDirection:"left"});


    // NOTIFICATION SYSTEM - SHOW / HIDE DROPDOWN
    $("nav.navigation-bar .notification-center .nc-system").click(function(){
        if(!$(document).find('#notification-system').hasClass('close')){
            $("#notification-system").removeClass("open");
            $("#notification-system").addClass("close");
        } else {
            $('#notification-system').removeClass('close').addClass('open')
        }

        $("body").addClass("ns-is-visible");
        $(this).removeClass("unread");

        get_sp_notifications();
        get_customer_notifications();

        tab_client_load_more_notifs();
        tab_sp_load_more_notifs();
    });

    // NOTIFICATION SYSTEM - CLICK OUTSIDE
    $(document).on('click',function(e){
        var target = $(e.target)
        if(!target.closest('nav.navigation-bar .notification-center .nc-system').length && !target.closest('.open').length){
            if(!$(document).find('#notification-system').hasClass('close')){
                $("#notification-system").removeClass("open");
                $("#notification-system").addClass("close");
            }
        }
    });


    // NOTIFICATION SYSTEM - MORE OPTION HOVER
    $(document).on('click', '#notification-system .ncni-more-options', function () {
        $(this).parents(".nc-notif-item").find(".ncni-more-options").toggleClass("open");
    });

    $(document).on('click', '#notification-system .ncni-more-options.open', function () {
        $("#notification-system .ncni-more-options").removeClass("open");
    });

    // NOTIFICATION SYSTEM - REDIRECT URL
    $(document).on('click', '#notification-system .nc-notif-item-in', function () {
        let htmlId = this.id;
        let notifId = htmlId.substring("notif-panel-".length);

        $.ajax({
            type: "GET",
            url: "/notifications_redirect",
            data: { id: notifId },
            success: function (data) {
                if (data.redirect_path === null) {
                    $(`#${htmlId}`).remove();
                } else {
                    window.location = data.redirect_path;
                }
            }
        });
    })

});

// NOTIFICATION SYSTEM .ncni-more-options - CLICK OUTSIDE
$(document).mouseup(function(e){
    var notification_center_container = $("#notification-system .ncni-more-options.open");
    if(!notification_center_container.is(e.target) && notification_center_container.has(e.target).length === 0){
        notification_center_container.removeClass("open");
    }
});
